const QueryStringKey = {
  DisplayName: 'display_name',
  Associated: 'associated',
  Type: 'type',
  ContainerKey: 'container_key',
  TemplateName: 'template_name'
};

export default QueryStringKey;
